import { atom } from 'jotai';

import { ROOT_FOLDER_ID } from '../types/fileSystem.js';

/**
 * Which folder is open. The path leading to it is not kept here: the listing
 * returns its own breadcrumb, so a client-side stack could only drift from it.
 */
export const openFolderIdAtom = atom<string>(ROOT_FOLDER_ID);
